import React from 'react';
import { readIsfrRecord } from './reviewRecord';
import { categoryStatus } from './checkDisplay';
import { CategoryTab, categoryTabId } from './CategoryTab';
import { FLAGS_TAB_ID, FlagsTab, flagsTabLabel } from './FlagsTab';
import { REVIEWER_TAB_ID, ReviewerBreakdown } from './ReviewerBreakdown';
import RequestDetails from './RequestDetails';
import { openTabAtTop } from './navigation';
import { REQUEST_DETAILS_TAB_ID } from './ReviewSummary';

export { REQUEST_DETAILS_TAB_ID };

/**
 * Every ISFR detail-page tab after the Approval Summary, in order: the reviewer
 * breakdown, the request's inputs, one tab per review
 * category (human verification first), then the flags. Category tabs and the
 * flags tab need the record's category rollup, so a record without a readable
 * one gets neither (its Approval Summary says why).
 *
 * @param {(tabId: string) => void} openTab opens a tab, for in-page links, which
 *   then land at the top of the tab they open
 */
export function isfrTabs(request, openTab) {
  const onOpenTab = openTabAtTop(openTab);
  const view = readIsfrRecord(request);
  const hasRollup = view.rollup.status === 'ok';
  return [
    {
      id: REVIEWER_TAB_ID,
      label: 'Reviewer Breakdown',
      content: <ReviewerBreakdown request={request} view={view} onOpenTab={onOpenTab} />,
    },
    { id: REQUEST_DETAILS_TAB_ID, label: 'Request Details', content: <RequestDetails request={request} /> },
    ...(hasRollup ? view.rollup.categories.map((category) => ({
      id: categoryTabId(category.key),
      label: `${categoryStatus(category).icon} ${category.label}`,
      content: <CategoryTab category={category} checks={view.checks} request={request} />,
    })) : []),
    ...(hasRollup ? [{
      id: FLAGS_TAB_ID,
      label: flagsTabLabel(view),
      content: <FlagsTab view={view} onOpenTab={onOpenTab} />,
    }] : []),
  ];
}
